export default {
  'sendverificationsms.sendverificationsms': 'ЗАПРОСИТЬ КОД ВЕРИФИКАЦИИ',
  'sendverificationsms.maintext':
    'Нажав кнопку «Отправить мне смс», вы получите на свой зарегистрированный телефон сообщение, содержащее проверочный код, который позволяет вам зарегистрироваться.',
  'sendverificationsms.sendsms': 'Пожалуйста, отправьте мне SMS',
};
